
export default {
  props: {
    countryCode: {
      type: String,
      required: true
    }
  },
  computed: {
    flagClass () {
      return this.countryCode?.toLowerCase()
    }
  }
}
